import { create } from 'zustand';

// 'nurse' is gone: the clinical voice tools moved into the chat tab, because they were never a
// different assistant — only a different tab. No persist middleware here, so no stale value to migrate.
export type AssistantTab = 'chat' | 'guide' | 'messages';

/**
 * Whether the assistant panel is open, and on which tab.
 *
 * Lifted out of the component so something else can open it. The case that forced it: a support
 * notification deep-links to a ticket, and the reply it is telling you about lives in the messages
 * panel — landing on a page that cannot open the conversation would make the notification useless.
 *
 * Deliberately only the UI state. Rooms, messages and unread stay in chatStore; this is just "is
 * the drawer open and which tab is showing".
 */
interface AssistantUiState {
  open: boolean;
  tab: AssistantTab;
  setOpen: (open: boolean) => void;
  toggle: () => void;
  /** Open the panel on a specific tab — what a deep link needs. */
  openWith: (tab: AssistantTab) => void;
  setTab: (tab: AssistantTab) => void;
}

export const useAssistantUi = create<AssistantUiState>((set) => ({
  open: false,
  tab: 'messages',
  setOpen: (open) => set({ open }),
  toggle: () => set((s) => ({ open: !s.open })),
  openWith: (tab) => set({ open: true, tab }),
  setTab: (tab) => set({ tab }),
}));
